'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* styles */

// main container
var TIMEPICKER_BACKGROUND = exports.TIMEPICKER_BACKGROUND = '#F2F2F2';
var FONT_FAMILY = exports.FONT_FAMILY = '"Roboto", sans-serif';
var DONE_BUTTON_COLOR = exports.DONE_BUTTON_COLOR = '#686868';
var DONE_BUTTON_BORDER_COLOR = exports.DONE_BUTTON_BORDER_COLOR = '#CCC';

// time
var TIME_BACKGROUND = exports.TIME_BACKGROUND = 'white';
var TIME_DEFAULT_COLOR = exports.TIME_DEFAULT_COLOR = '#8C8C8C';
var TIME_SELECTED_COLOR = exports.TIME_SELECTED_COLOR = '#8EDDFD';

// time dropdown
var DROPDOWN_BORDER = exports.DROPDOWN_BORDER = '#f4f4f4';
var DROPDOWN_COLOR = exports.DROPDOWN_COLOR = '#8c8c8c';
var DROPDOWN_SELECTED_COLOR = exports.DROPDOWN_SELECTED_COLOR = '#EAF8FF';

// clock wrapper
var CLOCK_WRAPPER_BACKGROUND = exports.CLOCK_WRAPPER_BACKGROUND = '#f4f4f4';
var CLOCK_WRAPPER_MERIDIEM_BACKGROUND = exports.CLOCK_WRAPPER_MERIDIEM_BACKGROUND = 'white';
var CLOCK_WRAPPER_MERIDIEM_COLOR = exports.CLOCK_WRAPPER_MERIDIEM_COLOR = '#898989';
var CLOCK_WRAPPER_MERIDIEM_BACKGROUND_COLOR_SELECTED = exports.CLOCK_WRAPPER_MERIDIEM_BACKGROUND_COLOR_SELECTED = '#E1EFF6';
var CLOCK_WRAPPER_MERIDIEM_TEXT_COLOR_SELECTED = exports.CLOCK_WRAPPER_MERIDIEM_TEXT_COLOR_SELECTED = '#898989';

// clock
var CLOCK_BACKGROUND = exports.CLOCK_BACKGROUND = 'white';
var CLOCK_NUMBER_COLOR = exports.CLOCK_NUMBER_COLOR = '#999999';
var CLOCK_HAND_ARM = exports.CLOCK_HAND_ARM = '#bceaff';
var CLOCK_HAND_CIRCLE_BACKGROUND = exports.CLOCK_HAND_CIRCLE_BACKGROUND = '#e6f7ff';
var CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = exports.CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = '#ade2fb';